import React from 'react';
import { Title, Body} from '@vds3/typography'
import { Button } from "@vds3/buttons";
import { MarginSpacerM } from '../../Checkout/styleTag';
import { connect } from 'react-redux';
import { Header } from '../Component/Header';
import PlanDetails from '../Component/PlanDetails';
import OrderSummaryPrint from '../../CheckoutNew/Component/OrderSummary/OrderSummaryPrint';
import ChatLink from '../../../Common/ChatLink/ChatLink';

const OrderconfirmationNew = (props) => {
    if(props.getFloatCartResponse){
        const {autoPay, paperFreeBilling} = props.installments || {};
    const autoPaperValue = (autoPay && paperFreeBilling) ? 'Y' : (!(autoPay || paperFreeBilling)) ? 'N' : (autoPay && !paperFreeBilling? 'NY':'YN')
    let cardHolderName = props.installments?.fullName?props.installments?.fullName.replace(/\s+/g, ""):"";
    let nameToDisplay=["Y","NY"].some((p)=>autoPaperValue=== p) && ["creditcards","debitcards"].some((c)=>c===props.savedPaymentMethodType)?cardHolderName.toLowerCase()===(props?.contactInfo?.firstName.trim()+props?.contactInfo?.lastName.trim()).toLowerCase()?"":props.installments?.fullName?props.installments?.fullName:"":""

    return (
        <>
        <div className='order-cnf-nw'>
            <div style={{width:'100%',backgroundColor:'black',padding:'2rem 4rem'}}>
            <ChatLink style={{ float: "right", paddingTop: "1rem" }} />


            <Title size="XLarge" color="white">Thank you,{["SoleOwner","Partner"].some((c)=>c===props?.customerType)?`${props?.contactInfo?.firstName} ${props?.contactInfo?.lastName}!`:nameToDisplay?nameToDisplay+"!":""} We're processing<br/> your order for {props?.contactInfo?.businessName}.</Title>
                <Body id="MONValue"color="white">{`Order number:${props?.MONNo??""}`}</Body>
            </div>
            <MarginSpacerM/>
           <Header/>
           <MarginSpacerM/>
            <PlanDetails {...props}/>
            <div className='ctn-shp-cnfrm'>
            <Button use="secondary" onClick={()=>window.print()}>Print details</Button>
            <Button use="secondary" onClick={()=>props.history.push('/')}>Continue Shopping</Button>
            </div>
        </div>
         <div className='printOption-order'>
            <OrderSummaryPrint/>
        </div>
        </>
    );
}else {
    props.history.push('/');
    return(<></>)
}
};


const mapStateToProps = state => {
    const { CheckoutPage,CustomizeOrder } = state;
    return {
        contactInfo: CheckoutPage.contactInfo,
		getFloatCartResponse: CustomizeOrder.getFloatCartResponse,
        MONNo: CheckoutPage.nextButtonBI?.MONNo,
        customerType: CheckoutPage?.creditCheck?.customerType,
        installments: CheckoutPage?.installments,
        savedPaymentMethodType: CheckoutPage?.savedPaymentMethodType,
    }
}
export default connect(mapStateToProps)(OrderconfirmationNew);